import type { LinariaClassName } from '@linaria/core'
import { mdiInformation, mdiInformationOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import type { IconProps } from '../../../Icons'
import Container from '../Container'

const InfoIcon = memo((props: IconProps) => {
    const { filled } = props
    return (
        <Icon
            path={filled ? mdiInformation : mdiInformationOutline}
            size={1}
            {...props}
        />
    )
})

interface InfoButtonProps {
    className?: LinariaClassName
    shadow?: boolean
    title?: string
    size?: number
    onClick: any
}

const InfoButton = memo((props: InfoButtonProps) => {
    const { className, shadow = true, title, onClick, size } = props
    return (
        <Container shadow={shadow} title={title}>
            <IconButton
                data-testid="IconButton__InfoButton"
                className={className}
                onClick={onClick}
            >
                <InfoIcon color="#eee" size={size} />
            </IconButton>
        </Container>
    )
})

export default InfoButton
